import { render } from "./StudentNotificationList.vue?vue&type=template&id=1287e702&scoped=true"
import script from "./StudentNotificationList.vue?vue&type=script&lang=js"
export * from "./StudentNotificationList.vue?vue&type=script&lang=js"

import "./StudentNotificationList.vue?vue&type=style&index=0&id=1287e702&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1287e702"]])

export default __exports__